<template>
  <div class="page_no_pms">
    <div class="border_top"></div>
    <div class="content">
      <img src="@/assets/images/components/no_pms.png" alt="" />
    <div class="tips" >抱歉，您没有权限访问该页面</div>
    <div>
      <el-button type="primary" class="btn" @click="backPrev">返回登录页</el-button>
    </div>
    </div>
  </div>
</template>

<script>
import mixins from "./Mixins"
export default {
  name: "noData",
  mixins:[mixins],
  created() {
    this.setLeftMenuShow_M(false);
  },
  methods: {
    backPrev() {
      window.sessionStorage.clear();
      window.location.href = "/#/userlogin";
    },
  },
};
</script>
<style lang="stylus" scoped>
.page_no_pms {
  background: #E9ECF3;
  .border_top {
    height:10px;
  }
  .content {
width:1010px;
  height:540px;
  margin: 0 auto;
  background:#fff;
  display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width:318px;
    height:235px;
    margin-top:60px;
  }
  .tips {
    color:#333333;
    font-size:12px;
    margin-top:40px;
  }
  .btn {
    width: 80px;
    height: 30px;
    margin-top: 40px;
    padding:0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NoPms.vue